import { fetchJSON } from '../utilities/fetch';

export interface ProductSpecsRectangle {
  width: number;
  height: number;
  anchorX: number;
  anchorY: number;
}

export interface ProductSpecs {
  cornerRadiusCentimeters: number;
  bleedCentimeters: ProductSpecsRectangle;
  trimCentimeters: ProductSpecsRectangle;
  safeAreaCentimeters: ProductSpecsRectangle;
}

type GetProductSpecsBySKUResponse = {
  printableAreaCornerRadius: number;
  bleed: ProductSpecsRectangle;
  trim: ProductSpecsRectangle;
  safeArea: ProductSpecsRectangle;
}[];

export async function getProductSpecsBySKU(sku: string, culture: string): Promise<ProductSpecs> {
  const specsBySide = await fetchJSON<GetProductSpecsBySKUResponse>(
    `https://specifications.products.vpsvc.com/api/skus/${sku}/rotatedSurfaces/${culture}`,
    { description: `get product specs by SKU: ${sku}` },
  );

  if (!Array.isArray(specsBySide) || specsBySide.length === 0) {
    throw new Error(
      'getProductSpecsBySKU returned an unexpected value. Expected an array with length > 0',
    );
  }

  const frontSideSpecs = specsBySide[0];

  return {
    cornerRadiusCentimeters: frontSideSpecs.printableAreaCornerRadius,
    bleedCentimeters: frontSideSpecs.bleed,
    trimCentimeters: frontSideSpecs.trim,
    safeAreaCentimeters: frontSideSpecs.safeArea,
  };
}
